import React, {ReactNode, useEffect, useState} from 'react';
import FogContainer, {EnumFog} from "../FogContainer/FogContainer";
import styles from './Modal.module.css'
import {CloseOutlined} from "@ant-design/icons";
import clsx from "clsx";
import {useLocation} from "react-router-dom";

interface IProps {
    children: ReactNode,
    options: {
        setStateModal: (boolean: boolean) => void,
        statusModal: boolean,
        fogPower: EnumFog
    }
}

const Modal = ({children, options}: IProps) => {

    const [isClosingProcess, setIsClosingProcess] = useState<boolean>(false)



    const closeHandler = () => {
        setIsClosingProcess(true)
        setTimeout(() => {
            options.setStateModal(false)
        }, 300)

    }
    const closeHandlerEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            closeHandler()
        }
    }

    useEffect(() => {
        document.addEventListener('keyup', closeHandlerEscape)

        return () => document.removeEventListener('keyup', closeHandlerEscape)
    }, [])


    const history = useLocation()


    useEffect(() => {
            return () => {
                closeHandler()
            }
        },
        [history.key])


    return (
        <div
            className={clsx(
            styles.modalWrapper,
            options.statusModal && styles.openModal,
            isClosingProcess && styles.closeModalWrapper
            )}>
            <CloseOutlined onClick={closeHandler} className={styles.closeModalIcon}/>
            <FogContainer fogPower={options.fogPower}>
                {children}
            </FogContainer>
        </div>
    );
};

export default Modal;